import { Component, OnInit,OnDestroy, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectDashboardService } from 'src/app/shared/services/project.dashboard.service';
import { NotifierService } from 'angular-notifier';
import { startWith, map } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';

interface ProjectDetails{
  name:string;
  id:string;
  status:string;
  org:string;
  org_uuid:string;
}

@Component({
  selector: 'app-update-project',
  templateUrl: './update-project.component.html',
  styleUrls: ['./update-project.component.scss']
})
export class UpdateProjectComponent implements OnInit, OnDestroy, AfterViewInit {
@Input() projectDetails: ProjectDetails;
@Output() updatePro =  new EventEmitter<boolean>();

  organizationList:any[] = [];
  filteredOptions: Observable<string[]>;
  projectStatus:boolean = false;
  public selectedProject:any = {};
  accessRole:any;
  defaultOrg:string='Crownit';
  allUserSelected = false;
  public allUser:any[]=[];
  public allShareRepoUser:any[]=[];
  allShareRepoUserSelected = false;
  projectForm = new FormGroup({
    organizationName: new FormControl(''),
    name:new FormControl(''),
    usersName: new FormControl(''),
    project_status: new FormControl(''),
    teamName: new FormControl(''),
    team_uuid: new FormControl([]),
    user_uuid:new FormControl([]),
    share_repository:new FormControl([])
  });

  constructor(
    public projectService:ProjectDashboardService,
    private notifier: NotifierService,
    private router: Router,
    private activatedRoute:ActivatedRoute,
    private logerror: LoginService
    ) { 
      this.accessRole = JSON.parse(localStorage.getItem('access'));
    }

  ngAfterViewInit(): void {}

  ngOnDestroy(){
    this.hideOldestNotification();
    this.projectDetails = null;
  }
  ngOnInit() {
    if (this.activatedRoute.snapshot.params['id']) {
      this.projectDetails['id'] = this.activatedRoute.snapshot.params['id']
    }
    this.projectStatus = this.projectDetails.status=='1'?true:false;
    this.getAllOrganization();
    this.getProjectDetails();
    this.filteredOptions = this.projectForm.controls.organizationName.valueChanges
    .pipe(
      startWith(''),
      map(value => this.filter(value))
      );
      // console.log("this.projectDetails,", this.projectDetails)
    if (!this.accessRole.super && this.projectDetails.org_uuid) {
      let query = {"org_uuid":this.projectDetails.org_uuid,"status":1,"isOrgUser":true};
      this.projectService.getTeamList(query);
      this.projectService.getUsers(query);
    }
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.organizationList.filter(option => option.organization_name.toLowerCase().includes(filterValue));
  }

   toggleAllUserSelection(): void {
    this.allUserSelected = !this.allUserSelected;
    if (this.allUserSelected) {
      const allUUIDs = this.projectService.userList.map(u => u.uuid);
      this.allUser = allUUIDs;
      this.allUser.push('selectAll');
      this.projectForm.get('user_uuid')?.patchValue(allUUIDs);
    } else {
      this.allUser = [];
      this.projectForm.get('user_uuid')?.patchValue([]);
      this.projectForm.get('team_uuid')?.patchValue([]);
    }
  }

  toggleAllShareRepoSelection(): void {
    this.allShareRepoUserSelected = !this.allShareRepoUserSelected;
    if (this.allShareRepoUserSelected) {
      const allUUIDs = this.projectService.shareRepoUserList.map(u => u.uuid);
      this.allShareRepoUser = allUUIDs;
      this.allShareRepoUser.push('selectAll');
      this.projectForm.get('share_repository')?.patchValue(allUUIDs);
    } else {
      this.allShareRepoUser = [];
      this.projectForm.get('share_repository')?.patchValue([]);
    }
  }

  changeOrg(){
    // console.log("in chenge org ", this.organizationList)
    this.defaultOrg = this.projectService.selectedProject.organization_name
    let query = {"org_uuid":this.organizationList.find(item =>{ return item.organization_name === this.defaultOrg}).uuid,"status":1,"isOrgUser":true};
    this.projectService.getTeamList(query);
    this.projectService.getUsers(query);
  }

  selectTeam(){
    let teamUsers = this.projectService.userList.filter(user => {
       return this.projectForm.value.team_uuid.find(team => {
          return team === user.team_uuid;
       });
    }).map(item=>{ return item.uuid});
    let removedTeam = "";
    this.projectService.selectedProject['oldTlist'].forEach(t_uuid => {if(this.projectForm.value.team_uuid.indexOf(t_uuid) == -1){
      removedTeam = t_uuid}});
    let individualUser = this.projectForm.value.user_uuid;
    if (removedTeam && removedTeam != "") {
      let removedTeamUsere = this.projectService.userList.filter(user => user.team_uuid == removedTeam).map(item=> item.uuid);
      individualUser = individualUser.filter(item => { return !removedTeamUsere.includes(item)})
    }
    this.projectService.selectedProject['oldTlist'] = this.projectForm.value.team_uuid;
    this.allUser = [...teamUsers,...individualUser];
    this.allUser = this.removeDuplicates(this.allUser);
    this.projectForm.patchValue({"user_uuid":this.allUser})
   }

   selectUsersToShareRepo(){
    this.checkAllShareRepoSelection();
  }
  checkAllShareRepoSelection(): void {
    let individualUser = this.projectForm.value.share_repository;
    this.allShareRepoUser = individualUser;
    if ((this.allShareRepoUser.includes('selectAll') && this.allShareRepoUser.length > this.projectService.shareRepoUserList.length) || (!this.allShareRepoUser.includes('selectAll') && this.allShareRepoUser.length >= this.projectService.shareRepoUserList.length)) {
      this.allShareRepoUser.push('selectAll');
      this.allShareRepoUserSelected = true;
    }else{
      this.allShareRepoUserSelected = false;
      this.allShareRepoUser = this.allShareRepoUser.filter(item => item != 'selectAll');
    }
    this.projectForm.patchValue({"share_repository":this.allShareRepoUser});
  }
 
   selectUsers(){
    //  let individualUser = this.projectForm.value.user_uuid;
    //  this.allUser = individualUser;
    //  this.projectForm.patchValue({"user_uuid":this.allUser})

    this.checkAllUserSelection();

   }

   checkAllUserSelection(): void {
    let individualUser = this.projectForm.value.user_uuid;
    this.allUser = individualUser;
    if ((this.allUser.includes('selectAll') && this.allUser.length > this.projectService.userList.length) || (!this.allUser.includes('selectAll') && this.allUser.length >= this.projectService.userList.length)) {
      this.allUser.push('selectAll');
      this.allUserSelected = true;
    }else{
      this.allUserSelected = false;
      this.allUser = this.allUser.filter(item => item != 'selectAll');
    }
    this.projectForm.patchValue({"user_uuid":this.allUser});
  }

   onUserChange(name){
    this.projectService.userList = this.projectService.filterByKey(this.projectService.orgUserList,'email',name,this.projectForm.value.user_uuid)
    this.checkAllUserSelection();
  }

  onTeamChange(name){
    this.projectService.teamList = this.projectService.filterByKey(this.projectService.orgTeamList,'name',name,this.projectForm.value.team_uuid)
  }

  onShareRepoUserChange(name){
    // console.log("name ",name)
    this.projectService.shareRepoUserList = this.projectService.filterByKey(this.projectService.orgUserList,'email',name,this.projectForm.value.share_repository);
    this.checkAllShareRepoSelection();
  }

  // filterByKey(dataList,key,value,selectedValue){
  //   // return dataList.filter(item =>{ return item[key].toLowerCase().includes(value.toLowerCase()) || selectedValue.includes(item['uuid'])})
  //   let filterList = dataList.filter(item =>{ return item[key].toLowerCase().includes(value.toLowerCase())})
  //   let selectedList = dataList.filter(item =>{ return selectedValue.includes(item['uuid'])})
  //   return [...filterList,...selectedList]
  // }

  removeDuplicates(arr: string[]): string[] {
    return Array.from(new Set(arr));
  }

  onUpdate(){
    this.updateProject();
  }
  onClose(){
    this.updatePro.emit(false);
  }

  getAllOrganization(){
    if (this.accessRole.super && this.accessRole['access_rules'] && this.accessRole['access_rules']['user_management'] && this.accessRole['access_rules']['user_management']['organizations'] && this.accessRole['access_rules']['user_management']['organizations']['view'] ) {
      this.projectService.getAllOrganization().subscribe(
        (data)=>{
          this.organizationList = typeof data['message'] == 'string' ? [] : data['message'];
          this.changeOrg();
        }
      );
    }else{
      this.organizationList = [];
    }
  }
  public showNotification( type: string, message: string ): void {
		this.notifier.notify( type, message );
	}

	public hideOldestNotification(): void {
		this.notifier.hideOldest();
	}

  updateProject(){
    let org_id:string;
    if(this.accessRole.super === true){
      let id:any = this.organizationList.filter(option => option.organization_name.toLowerCase().includes(this.projectForm.value.organizationName.toLowerCase()))
      org_id = id[0].uuid;
    }else{
      org_id = this.accessRole.org_id;
    }
    this.allUser = this.projectForm.value.user_uuid.filter(item => item != 'selectAll')
    let dataProject = {
      project_id: this.projectService.selectedProject.uuid,
      status:this.projectForm.value.project_status,
      organization_id: org_id,
      name:this.projectForm.value.name?this.projectForm.value.name:this.projectService.selectedProject.name,
      // user_uuid:this.projectForm.value.user_uuid,
      user_uuid:this.allUser,
      share_repository:this.allShareRepoUser.filter(item => item != 'selectAll'),
      team_uuid:this.projectForm.value.team_uuid,
    };
//     debugger
    // console.log(dataProject);

    this.projectService.updateProject(dataProject).subscribe(
      (data)=>{
        if(data){
        }
        if(data['status'] === 1){
          this.updatePro.emit(true);
          this.showNotification('success',"Project Updated");
          this.onClose();
          this.projectForm.reset();
        }else{
          this.showNotification('error',data['message']);
        }
      },
      (error)=>{
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.showNotification('error', 'User is not authorised');
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.showNotification('error', 'Something went wrong');
        }
      }
    )
  }

  getProjectDetails(){
    let body = {"uuid":this.projectDetails.id}
    // console.log("body is ",body)
    this.projectService.getProjectDetails(body)
    .subscribe(result =>{
      if (result['status'] == 1) {
        // this.changeOrg();
        this.selectedProject = result['project'];
        this.selectedProject['ulist'] = this.selectedProject['userList'].map(item => item.uuid);
        this.selectedProject['srulist'] = this.selectedProject['shareRepoList'].map(item => item.uuid) || [];
        this.selectedProject['tlist'] = this.selectedProject['teamList'].map(item => item.uuid);
        // console.log("Anand",this.selectedProject)
        // this.projectService.selectedProject.name = this.selectedProject.name;
      }
    })
  }
}
